export default __webpack_public_path__ + "static/1-login-c9a399cdc18d4661d31a61f7eefa88c4.png";